import React, { useEffect, useRef, useState } from 'react'
import { DecryptedOBJ, EncryptedText } from '../../utils/Encryption';
import { authenAll } from '../../_actions/sso.authen';
import lineConfig from '../../_actions/authLine/lineConfig';
import { Base_API } from '../../_actions/matcher';
import { useParams } from 'react-router-dom';
import { NhealthAction } from '../../_actions/action.api';
import { jwtVerify, SignJWT } from 'jose';
import useLineLogin from '../../_actions/authLine/lineLogin';
import { ALERT } from '../../components/CustomAlert';

const secret = new TextEncoder().encode(Base_API.primo_jwt_secret);

export default function PrimoInitDest() {
    let onceMount = useRef(true);
    let {primoType} = useParams();

    useEffect(() => {
        if(onceMount.current)
        {
            initPrimoDirection();
            onceMount.current = false;
        }
    })


    const initPrimoDirection = async() => {
        let lowprimoType = String(primoType).toLowerCase();
        // set url callback
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)
       
        let lineConfigPrimo = lowprimoType === "membercardinfo" ? lineConfig.primo_privilege 
        : lowprimoType === "pointhistory" ? lineConfig.primo_pointhistory 
        : lowprimoType === "rewards" ? lineConfig.primo_wallet : ''

        await authenAll(lineConfigPrimo); // line login + sso
        let lineProfile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null; 
        console.log('line Profile: ', lineProfile);
        if(!!lineProfile)
        {
            let memberData = !!localStorage.getItem(process.env.REACT_APP_ENC_NAME_MEMBER_LAB_DATA) ? DecryptedOBJ(localStorage.getItem(process.env.REACT_APP_ENC_NAME_MEMBER_LAB_DATA)) : null;
            console.log('memberData: ', memberData);
            if(!!memberData)
            {
                let memberCode = memberData.membercode;
                let cardNo = memberData.cardNo;
                const payload = {
                    iat: Math.floor(Date.now() / 1000),
                    exp: Math.floor(Date.now() / 1000) + 3600,
                    aud: "Primo",
                    line_channel_id: lineConfig.line_channel_id,
                    line_token: lineProfile.id_token,
                    membercode: memberCode,
                    card_no: cardNo
                };
                      
                const token = await new SignJWT(payload)
                .setProtectedHeader({ alg: 'HS256' })
                .sign(secret);
    
                if(lowprimoType === "membercardinfo")
                {
                    location.href = encodeURI(`${Base_API.primo}/privilege-redemption?data=${token}`)        
                }
                if(lowprimoType === 'pointhistory')
                {
                    location.href = encodeURI(`${Base_API.primo}/?data=${token}`)         
                    // location.href = encodeURI(`${Base_API.primo}/point-history?data=${token}`)         
                }
                if(lowprimoType === 'rewards')
                {
                    location.href = encodeURI(`${Base_API.primo}/wallet?data=${token}`)          
                }
            }else
            {
                ALERT.customAlert('แจ้งเตือน', 'ไม่พบข้อมูลสมาชิกของท่าน', 'ล็อกอินอีกครั้ง', () => {
                    localStorage.removeItem('line_profile');
                    location.href = `${Base_API.pathWeb}/n-health/primo/${lowprimoType}`
                });
            }
        }
    }

    return (
        <div className="sls-loader-container">
            <div className="sls-loader"></div>
        </div>
    )
}